import { useToast } from '@chakra-ui/react';
import { CardFeesEnum } from '@Config/urls/cardManagementSystem.url';
import CommonCardFeesFormUI from '@Modules/cardManagementSystem/cardholder/components/forms/cardFees/CommonCardFeesFormUI';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import { useParams } from 'react-router-dom';
import commonCardFeesFormMeta, { ICommonCardFeesFormMeta } from './commonCardFeesFormMeta';

function getTitle (page: string | undefined) {
    let title: string = "";
    let meta: Partial<ICommonCardFeesFormMeta> = {...commonCardFeesFormMeta};
    
    if(page !== CardFeesEnum.MEMBERSHIP_FEE && page !== CardFeesEnum.RECURRING_FEE) {
        delete meta.periodicity;
    }
   
    switch (page) {
        case CardFeesEnum.MEMBERSHIP_FEE:
            title = "Frais d'Adhésion";
            break;
    
        case CardFeesEnum.CUSTOMIZATION_FEES:
            title = "Frais de Personnalisation";
            break;
    
        case CardFeesEnum.RENEWAL_FEE:
            title = "Frais de Renouvellement Carte";
            break;
    
        case CardFeesEnum.REPLACEMENT_FEE:
            title = "Frais Remplacement Carte";
            break;
    
        case CardFeesEnum.PIN_RECALCULATION_FEE:
            title = "Frais Re-calcul Pin";
            break;
    
        case CardFeesEnum.RECURRING_FEE:
            title = "Frais Périodiques Divers";
            break;
    
        case CardFeesEnum.ONE_TIME_FEE:
            title = "Frais Ponctuels";
            break;
    
        default:
            break;
    }

    return {title, meta};
};

const CommonCardFeesFormHandler = () => {
    
  const toast = useToast();

  const { cardFeePage } = useParams();
  console.log("cardFeePage", cardFeePage);
  const {title, meta} = getTitle(cardFeePage);

    // Initialize react Query to GET Data
  const queryKey = [title.replaceAll(" ", "")];
  const {
    data,
    isLoading,
  } = useQuery({
    queryKey: queryKey,
    queryFn: async () => {
        // TODO: Replace this by your fetcher function
        return new Promise(function(resolve) {
            setTimeout(() => resolve("data"), 500);
        });
    },
    onSuccess: (data_: any) => {
      // console.log(data_);
    },
    onError: (data_: any) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de la récupération des données",
        isClosable: true,
        status: 'error',
      });
    },
  });

  
  const { isLoading: isSubmitting } = useMutation( async() =>{}, {
    onSuccess: (data) => {
      console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Sauvegarde effectuée avec succès',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      toast({
        position: 'top-right',
        title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
        isClosable: true,
        status: 'error',
      });
      console.log('Error: ', error);
    },
  });

  const onSubmit = async (payload: any) => {
    console.log('payload: ', payload);
    // TODO: Uncomment the following lines to put the logic of backend feedback operation
    /*try {
         await mutateAsync();
     } catch (error) {
         console.log(error);
     }*/
  };

  return <CommonCardFeesFormUI meta={meta} onSubmit={onSubmit} isLoading={isLoading} isSubmitting={isSubmitting} title={title} />;
};

export default CommonCardFeesFormHandler;
